export const MINIMUM_REQUIRED = 'minimumRequired';
export const CUSTOM_AMOUNT = 'customAmount';
